import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/notification_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  title_eq: {
    model_name: 'Notification',
    column_type: 'string',
    label_key_path: 'notification.title',
  },
  is_read_eq: {
    column_type: 'boolean',
    model_name: 'Notification',
    label_key_path: 'notification.isRead',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Notification', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Notification', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
